import { render, staticRenderFns } from "./layouts.vue?vue&type=template&id=aa1374b8&scoped=true&"
import script from "./layouts.vue?vue&type=script&lang=js&"
export * from "./layouts.vue?vue&type=script&lang=js&"
import style0 from "./layouts.vue?vue&type=style&index=0&id=aa1374b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1374b8",
  null
  
)

export default component.exports